import React from 'react';
import CurrencyFormat from 'react-currency-format';

function CustomCurrencyFormat({ value, prefix }) {
  return (
    <CurrencyFormat
      value={value}
      displayType={'text'}
      thousandSeparator={true}
      prefix={prefix || 'RM'}
      renderText={(value) => <div>{value}</div>}
    />
  );
}

export default CustomCurrencyFormat;